import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ImageOrderingPage } from '@order/pages/image-ordering/image-ordering.page';
import { PlatformEnum } from '@panamax/app-state';
import {
  ImageOrderingApiResponse,
  ImageOrderingResult,
} from '@shared/models/ai-agent-response';

@Component({
  selector: 'app-image-ordering-result',
  templateUrl: './image-ordering-result.component.html',
  styleUrls: ['./image-ordering-result.component.scss'],
})
export class ImageOrderingResultComponent {
  private data: ImageOrderingApiResponse;
  public imageOrderingOptionsActionSheetIsOpen = false;
  public imageOrderingOptionsButtons = [
    {
      text: this.translateService.instant('i18n.imageOrderingPage.camera'),
      handler: () => this.cameraOptionEmitter.emit(),
    },
    {
      text: this.translateService.instant('i18n.imageOrderingPage.uploadFile'),
      handler: () => this.uploadFileOptionEmitter.emit(),
    },
  ];
  @Output() navigateToCartEmitter = new EventEmitter<boolean>();
  @Output() navigateToListsEmitter = new EventEmitter<boolean>();
  @Output() cameraOptionEmitter = new EventEmitter<boolean>();
  @Output() uploadFileOptionEmitter = new EventEmitter<boolean>();
  @Input() isNewFormatEnabled: boolean;
  @Input() hasCameraAccess: boolean;
  @Input() set imageOrderingResults(results: ImageOrderingResult[]) {
    this.totalUploads = results.reduce(
      (acc, result) => acc + result.matches.length,
      0,
    );
    this.notFoundProducts = results.reduce(
      (acc, result) =>
        acc +
        result.matches.filter(
          ({ matchedProductNumber, productNumber }) =>
            !matchedProductNumber && !productNumber,
        ).length,
      0,
    );

    if (this.totalUploads > 0) {
      this.successPoint1 = this.translateService.instant(
        'i18n.imageOrderingPage.uploadCount',
        {
          count: this.totalUploads,
        },
      );
    }
    if (this.notFoundProducts > 0) {
      this.successPoint2 = this.translateService.instant(
        'i18n.imageOrderingPage.successPoint2',
        {
          fail: this.notFoundProducts,
        },
      );
    }
  }
  @Input() set apiResp(apiResp: ImageOrderingApiResponse) {
    if (!apiResp) return;
    this.data = apiResp;
    this.successPoint1 = '';
    this.successPoint2 = '';
    this.maxFileSizeMB = ImageOrderingPage.MAX_FILE_SIZE_MB;
    this.allowedFileTypes = ImageOrderingPage.ALLOWED_FILE_TYPES;
    this.isNaNRequestedCounter = isNaN(apiResp?.productsRequestedCount);
    if (!this.isNaNRequestedCounter) {
      this.successPoint1 = this.translateService.instant(
        'i18n.imageOrderingPage.successPoint1',
        {
          ok: apiResp.productsRequestedCount,
        },
      );
    }

    if (
      !isNaN(apiResp.productsNotFoundCount) &&
      apiResp.productsNotFoundCount > 0
    ) {
      this.successPoint2 = this.translateService.instant(
        'i18n.imageOrderingPage.successPoint2',
        {
          fail: apiResp.productsNotFoundCount,
        },
      );
    }
  }

  get apiResp(): ImageOrderingApiResponse {
    return this.data;
  }

  @Input() set platformType(pType: string) {
    this.isDesktop = pType === PlatformEnum.desktop;
    this.isTablet = pType === PlatformEnum.tablet;
    this.isMobile = pType === PlatformEnum.mobile;
  }

  @Input() showFileSizeError: boolean;
  @Input() showFileTypeError: boolean;

  totalUploads: number;
  notFoundProducts: number;
  successPoint1: string;
  successPoint2: string;
  isDesktop: boolean;
  isTablet: boolean;
  isMobile: boolean;
  isNaNRequestedCounter: boolean;
  maxFileSizeMB = ImageOrderingPage.MAX_FILE_SIZE_MB;
  allowedFileTypes = ImageOrderingPage.ALLOWED_FILE_TYPES;

  constructor(private translateService: TranslateService) {}

  showOptions() {
    //Prevent Warning: Blocked aria-hidden on an element because its descendant retained focus.
    const buttonElement = document.activeElement as HTMLElement; // Get the currently focused element
    buttonElement?.blur(); // Remove focus from the button
    if (!this.isDesktop) {
      this.imageOrderingOptionsActionSheetIsOpen = true;
    }
  }
}
